module.exports = __webpack_public_path__ + "img/5af6e7c.png";